// The glyph shown wherever an image cannot be displayed. Its own module so BlobImage and
// UserUploadedImage share one copy: BlobImage's public API is unchanged, so its 26 importers
// are untouched.
export const PlaceholderIcon = () => (
	<svg
		aria-hidden="true"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="size-8"
	>
		<rect x="3" y="3" width="18" height="18" rx="2" />
		<circle cx="8.5" cy="8.5" r="1.5" />
		<path d="m21 15-5-5L5 21" />
	</svg>
);
